module.exports = __webpack_public_path__ + "static/jc04657-preparation-storage-disposal-dbb1be10e20f67db4799ce140ba960d2.png";